<template src="./registroSintesi.html"></template>

<script>
import DichiarazioniFSC from '@/components/registroSintesi/DichiarazioniFSC.vue'
import CategorieFSC from '@/components/registroSintesi/CategorieFSC.vue'
import FattoriConversioneFSC from '@/components/registroSintesi/FattoriConversioneFSC.vue'
import FattoriConversioneFSCUscita from '@/components/registroSintesi/FattoriConversioneFSCUscita.vue'
import CommesseFSC from '@/components/registroSintesi/CommesseFSC.vue'
import MateriePrime from '@/components/registroSintesi/MateriePrime.vue'
import DeclassamentoMateriale from '@/components/registroSintesi/DeclassamentoMateriale.vue'
import EsportaDati from '@/components/registroSintesi/EsportaDati.vue'

import { get_log_commesse, get_materiali, get_verifica_accesso } from '@/api/api.registroSintesi.js'

export default {
    components: {
        DichiarazioniFSC,
        CategorieFSC,
        FattoriConversioneFSC,
        CommesseFSC,
        MateriePrime,
        DeclassamentoMateriale,
        EsportaDati,
        FattoriConversioneFSCUscita,
    },

    data() {
        return {
            tab: 0,
            showDichiarazioni: false,   //dialog anagrafica dichiarazioni FSC
            showCategorie: false,       //dialog anagrafica categorie FSC
            showFattori: false,         //dialog anagrafica fattori di conversione
            showCommessa: false,        //dialog inserimento e modifica commesse
            showMatPrima: false,        //dialog inserimento e modifica materie prime

            search: '',
            datiCommesse: [],
            headersCommesse: [
                { text: 'ID', value: 'ID' },
                { text: 'Riferimento', value: 'Riferimento' },
                { text: 'Cliente', value: 'ClienteUscita' },
                { text: 'Gruppi di prodotto', value: 'GruppiProdotto' },
                { text: 'Essenze', value: 'Essenze' },
                { text: 'Dichiarazioni FSC', value: 'DichiarazioniFSC' },
                /* { text: 'Essenza', value: 'essenza' }, */
                { text: 'Terzisti', value: 'Terzisti' },
                { text: 'Azioni', value: 'actions' },
            ],
            elementoSel: {},

            materiaSel: {},
            headersMatPrime: [
                { text: 'Codice', value: 'idMateriale' },
                { text: 'Fornitore', value: 'fornitore' },
                { text: 'DDT', value: 'nBollaText' },
                { text: 'Fattura', value: 'nFatturaText' },
                { text: 'Gruppo di prodotto', value: 'gruppoCategoriaFSC' },
                { text: 'Essenza', value: 'essenza' },
                { text: 'Dichiarazione FSC', value: 'dichiarazioneFSC' },
                { text: 'Unità Misura', value: 'um' },
                { text: 'QTA', value: 'qta' },
                { text: 'Descrizione', value: 'descrizione' },
                { text: 'Azioni', value: 'actions' },
            ],

            datiMatPrime: [],

            companyCode: "",
            cliente: "",

            dialogDeclassamento: false,
            dialogDownload: false,

            showFattoriUscita: false
        }
    },

    methods: {
        indietro() {
            if (this.role !== "utente")
                this.$router.push({ path: "/registro" });
            else
                this.$router.push({ path: "/" });
        },

        async caricaDati() {
            if (this.tab === 0) {
                await this.caricaDatiMatPrime();
            } else if (this.tab === 1) {
                await this.caricaDatiCommesse();
            }
        },

        //#region Commesse

        apriDialogCommesse(item = null) {
            if (!item) {
                this.elementoSel = {
                    CompanyCode: this.companyCode,
                    IdCommessa: -1,
                    riferimento: '',
                    cliente: this.cliente,
                    ClienteUscita: '',
                    gruppoProdotto: '',
                    dichiarazioneFSC: '',
                    essenza: '',
                    Qta: 0,
                    Ddt: [],
                    Fatture: [],
                    TerzistiInv: [],
                    TerzistiRic: [],
                    Sezioni: [],
                };
            } else {
                this.elementoSel = { ...item };
            }
            this.showCommessa = true;
        },

        async caricaDatiCommesse() {
            let par = "";
            if (this.role !== "utente")
                par = "?companyCode=" + this.companyCode;
            let res = await get_log_commesse(par);
            this.datiCommesse = res.data;
        },

        chiudiCommessa(aggiorna = false) {
            this.showCommessa = false;
            if (aggiorna) {
                this.caricaDatiCommesse();
            }
            this.elementoSel = {};
        },

        //#endregion

        //#region Materie Prime
        async caricaDatiMatPrime() {
            let par = "";
            if (this.role !== "utente")
                par = "?companyCode=" + this.companyCode;
            let res = await get_materiali(par);
            this.datiMatPrime = res.data;
        },

        duplicaRigo(item) {
            let itemDup = { ...item };
            itemDup.idMateriale = -1;
            this.apriDialogMatPrima(itemDup);
        },

        apriDialogMatPrima(item = null) {
            if (!item) {
                this.materiaSel = {
                    CompanyCode: this.companyCode,
                    IdMateriale: -1,
                    Fornitore: '',
                    NBolla: '',
                    DataBolla: '',
                    NFattura: '',
                    DataFattura: '',
                    GruppoCategoriaFSC: '',
                    Essenza: '',
                    DichiarazioneFSC: '',
                    Um: '',
                    Qta: 0,
                    Descrizione: '',
                    Pezzi: 0,
                    Sezione: 0,
                    Spessore: 0,
                    Lunghezza: 0,
                };
            } else {
                this.materiaSel = { ...item };

                if (this.materiaSel.DataBolla)
                    this.materiaSel.DataBolla = this.materiaSel.DataBolla.substring(0, 10);

                if (this.materiaSel.DataFattura)
                    this.materiaSel.DataFattura = this.materiaSel.DataFattura.substring(0, 10);
            }
            this.showMatPrima = true;
        },


        chiudiMatPrima(aggiorna = false) {
            this.showMatPrima = false;
            if (aggiorna) {
                this.caricaDatiMatPrime();
            }
            this.materiaSel = {};
        },

        //#endregion

        //#region Declassamento materiale

        apriDialogDeclassamento() {
            this.dialogDeclassamento = true;
        },

        chiudiDialogDeclassamento() {
            this.dialogDeclassamento = false;
        },
        //#endregion

        esportaDati() {
            this.dialogDownload = true;
        },

        chiudiEsporta() {
            this.dialogDownload = false;
        },

        async verificaAziendaUrl() {
            // Al primo caricamento diretto della pagina (es. url incollato in barra indirizzi)
            // il ruolo utente puo' non essere ancora stato caricato in store (richiesta
            // asincrona avviata da Main.vue): senza attenderlo i controlli sotto verrebbero
            // saltati (this.role vuoto) lasciando la pagina accessibile senza verifica.
            if (!this.role) {
                await this.$store.dispatch("user/userInfo");
            }

            this.companyCode = this.$route.params.codice || null;

            // Un utente cliente non deve mai poter vedere/operare su un'altra azienda modificando
            // il codice nell'URL: se non corrisponde alla propria azienda, si forza quest'ultima
            // e si corregge l'indirizzo, invece di fidarsi di quanto scritto nell'URL.
            if (this.role === "utente" && this.companyCode !== this.miaAzienda) {
                this.companyCode = this.miaAzienda;
                this.$router.replace({ path: "/registro/" + this.miaAzienda }).catch(() => { });
                return;
            }

            // Un auditor puo' vedere solo le aziende a cui e' stato assegnato: se prova ad accedere
            // ad un'altra azienda modificando il codice nell'URL, viene rimandato all'elenco.
            if (this.role === "auditor" && this.companyCode) {
                let res = await get_verifica_accesso(this.companyCode);
                if (!res.data) {
                    this.$router.replace({ path: "/registro" }).catch(() => { });
                    return;
                }
            }

            if (this.companyCode) {
                this.cliente = this.$route.query.cliente || "";
                this.caricaDati();
            } else {
                this.$router.push({ path: "/" });
            }
        },
    },

    mounted() {
        this.verificaAziendaUrl();
    },

    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        },

        miaAzienda() {
            return this.$store.getters['user/getCompanyCode'];
        },
    },

    watch: {
        tab() {
            this.caricaDati();
        },

        // copre anche il caso (raro con lo history mode del router) in cui il parametro :codice
        // cambi senza un ricaricamento completo della pagina, che ometterebbe mounted()
        '$route.params.codice'() {
            this.verificaAziendaUrl();
        },
    }
}
</script>